import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { FORMAT_DATE_BACK, formatDate } from 'ui-seeker/utils'

import { PARITY_URL } from 'app/@common/constants'


export default function SelectInfo({...props}) {

    if (!props.date || !props.nights || !props.occupancy) return <></>

    const myProps = {
        urlAjax: PARITY_URL.INFO,
        placeholder: 'Info',
        icon: { icon: 'info' },
        method: 'POST',
        isMulti: false,
        isClearable: true,
        extraParams: {
            roomID: props.room,
            id_rate: props.rate,
            nights: props.nights, 
            occupancy: props.occupancy, 
            devices: props.devices,
            hotelID: props.hotels,
            id_site: props.sites,
            boardID: props.board,
            dateRange: props.date,
            ...props.id_report_execution && { id_report_execution: props.id_report_execution },
            ...props.date === 'custom' && { 
                startDate: formatDate(props.customDates[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(props.customDates[1], { format: FORMAT_DATE_BACK })
            }
        },
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}